// extracted by mini-css-extract-plugin
export var main_headline = "MainHeadline-module--main_headline--f5908";